import { SwiperSlide } from 'swiper/react';
import React from 'react';

import {
    Carousel,
    CarouselArrowNavigation,
    CarouselWrapper
} from '$partials/base/carousel';

import { Button } from '$partials/ui';
import ArticleListingItem from '$partials/items/article-listing-item';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ArticleListingCarouselBlock}
 */

const ArticleListingCarousel = ({
    listingPage,
    items,
    title,
    text
}) => {
    return (
        <section className='bg-surface-panel-red col-padding'>
            <h2 className='type-style-sans-h2-med w-full'>
                {title}
            </h2>

            <div className='col-wrapper-breakout'>
                <Carousel
                    swiperConfig={{
                        a11y: { enabled: true },
                        slidesPerView: 1.2,
                        slidesOffsetBefore: 8,
                        slidesOffsetAfter: 8,
                        breakpoints: {
                            992: {
                                slidesPerView: 2.35,
                            },
                            1440: {
                                slidesPerView: 3.15,
                                slidesOffsetBefore: 16,
                                slidesOffsetAfter: 16
                            }
                        },
                        spaceBetween: 8,
                        grabCursor: false,
                    }}>
                    <div className='w-full flex justify-between mb-16 col-padding'>
                        {text && (
                            <p className='type-style-sans-h3 w-full sm:w-7/12'>
                                {text}
                            </p>
                        )}
                        <div className='hidden sm:flex justify-end items-end'>
                            <Button
                                as='a'
                                className='button-outcome'
                                href={listingPage?.url}>
                                {'View all'}
                            </Button>
                            {/* Desktop */}
                            {items.length > 3 && (
                                <div className='hidden md:block ml-8 md:ml-16'>
                                    <CarouselArrowNavigation />
                                </div>
                            )}
                            {/* Tablet */}
                            {items.length > 2 && (
                                <div className='hidden sm:block md:hidden ml-8 md:ml-16'>
                                    <CarouselArrowNavigation />
                                </div>
                            )}
                        </div>
                    </div>

                    <CarouselWrapper>
                        {items.map(item => {
                            if (!item.id) { return null; }

                            return (
                                <SwiperSlide
                                    aria-roledescription='slide'
                                    className='select-none cursor-pointer flex flex-wrap mt-4'
                                    key={item.id}
                                    role='group'>
                                    <ArticleListingItem {...item} />
                                </SwiperSlide>
                            );
                        }).filter(Boolean)}
                    </CarouselWrapper>
                </Carousel>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticleListingCarousel;
